var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    { ref: "dialog", attrs: { title: "We're here to help", closable: "" } },
    [
      !_vm.isSent
        ? [
            _c("p", [
              _vm._v("Please visit our "),
              _c("a", { attrs: { href: "/help", target: "_blank" } }, [
                _vm._v("help section"),
              ]),
              _vm._v(" providing details on how to use the cloud service."),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "You may also send us support question(s) using the form below and we will come back to you by e-mail, normally within 24 hours Monday - Friday."
              ),
            ]),
            _vm._v(" "),
            _c("ui-text-area", {
              attrs: { autofocus: "", autogrow: "", label: "Message" },
              model: {
                value: _vm.feedbackText,
                callback: function ($$v) {
                  _vm.feedbackText = $$v
                },
                expression: "feedbackText",
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSent
        ? [
            _c("p", [
              _vm._v("Thank you for your message, we will reply shortly."),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ui-dialog-footer",
        [
          !_vm.isSent
            ? _c("ui-button", {
                attrs: {
                  disabled: _vm.isProcessing || _vm.feedbackText.length === 0,
                  primary: "",
                  text: "Send",
                  tooltip: "Send message",
                },
                on: { click: _vm.postFeedback },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isSent
            ? _c("ui-button", {
                attrs: { primary: "", text: "Close" },
                on: { click: _vm.close },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }